module.exports = __webpack_public_path__ + "static/img/img-main-award-m.9918bc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img-main-award-m.png
// module id = dyTg
// module chunks = 18